import { isEmpty } from "ramda";
import { useNavigate } from "react-router-dom";
import { Button, Panel, Skeleton, Typography } from "@/components/atoms";
import { EmptyState } from "@/components/molecules";
import { useAppSelector } from "@/redux/hooks";
import { useGetUserAccountHistoryParams } from "../hooks/useGetUserAccountHistoryParams";
import { useGetUserAccountHistoryQuery } from "@/redux/apis/userAccount/userAccountApi";
import { UserAccountHistoryTable } from "./UserAccountHistoryTable";
import { userAccountHistorySelector } from "@/redux/slices/userAccount/selectors";
import { useGetUserAccountProfileQuery } from "@/redux/apis/userAccount/userAccountProfileApi";
import { Restricted } from "@/components/pages";

export const UserAccountHistoryPanel = () => {
  const navigate = useNavigate();
  const { params } = useGetUserAccountHistoryParams();
  const { isFetching: isFetchingHistory } = useGetUserAccountHistoryQuery(params, { refetchOnMountOrArgChange: true });
  const { isFetching: isFetchingProfile, data } = useGetUserAccountProfileQuery(params.id, { refetchOnMountOrArgChange: true });
  const items = useAppSelector(userAccountHistorySelector);
  const displayName = data ? `${data.firstName} ${data.lastName}` : "";
  const isFetching = isFetchingHistory || isFetchingProfile;
  const isEmptyHistory = isEmpty(items) && !isFetching;

  if (!isFetching && !data) return <Restricted />;

  return (
    <div className="flex flex-col">
      <div className="flex">
        <Button startIcon="ArrowLeft" variant="tertiary-light" size="sm" onClick={() => navigate("../")}>
          Back
        </Button>
      </div>
      <Panel className="mt-5">
        <header className="flex">
          <div className="flex-1">
            <Typography variant="h3" className="leading-8">
              History Logs
            </Typography>
            <Typography className="text-neutral-dark-gray">{displayName}</Typography>
          </div>
        </header>
        {isEmptyHistory ? (
          <EmptyState title="History Logs" description="There are currently no history logs available for this user account" />
        ) : isFetching ? (
          <Skeleton />
        ) : (
          <UserAccountHistoryTable items={items} className="mt-4" />
        )}
      </Panel>
      {!isFetching && <UserAccountHistoryTable.Pagination />}
    </div>
  );
};
